// extracted by mini-css-extract-plugin
export default {"root":"EditNetworkForm_root__epcek","submit":"EditNetworkForm_submit__je1nY"};